module.exports = __webpack_public_path__ + "static/media/reactlogo.18a86995.png";